export { default } from './DealerCard';
